import React from 'react';
import { withStyles, ButtonBase } from '@material-ui/core';

import fileBlockStyle from 'assets/jss/material-dashboard-pro-react/components/fileBlockStyle';
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import Tooltip from "@material-ui/core/Tooltip";

import Button from "components/CustomButtons/Button.jsx";

import Delete from "@material-ui/icons/Delete";
import Share from "@material-ui/icons/Share";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faFileWord, faFilePowerpoint, faFileExclamation, faFileImage, faFileArchive, faFileCode, faFolders, faReply } from '@fortawesome/pro-solid-svg-icons';

const decideColor = (fileType) => {
    switch (fileType) {
        case "pdf":
            return "danger"
        case "csv":
        case "xls":
        case "xlsx":
        case "rar":
        case "zip":
        case "7z":
        case "gz":
        case "tar":
        case "tgz":
            return "success";
        case "doc":
        case "docx":
            return "info";
        case "ppt":
        case "pptx":
        case "pptm":
            return "warning";
        case "png":
        case "jpeg":
        case "jpg":
        case "svg":
        case "bmp":
        case "gif":
        case "tif":
        case "ico":
        case "icon":

        case "folder":
            return "primary"
        case "back":
            return "info"
        default:
            return "rose";
    }
}

const decideIcon = (fileType) => {
    switch (fileType) {
        case "pdf":
            return faFilePdf;
        case "csv":
        case "xls":
        case "xlsx":
            return faFileExcel;
        case "rar":
        case "zip":
        case "7z":
        case "gz":
        case "tar":
        case "tgz":
            return faFileArchive;
        case "doc":
        case "docx":
            return faFileWord;
        case "ppt":
        case "pptx":
        case "pptm":
            return faFilePowerpoint;
        case "png":
        case "jpeg":
        case "jpg":
        case "svg":
        case "bmp":
        case "gif":
        case "tif":
        case "ico":
        case "icon":
            return faFileImage;
        case "json":
        case "cs":
        case "asax":
        case "asp":
        case "aspx":
        case "aspm":
        case "csproj":
        case "config":
        case "conf":
        case "sln":
        case "dll":
        case "js":
        case "jsx":
        case "ts":
        case "tsx":
        case "css":
        case "scss":
        case "less":
        case "cpp":
        case "c":
        case "md":
        case "html":
        case "htm":
        case "eof":
        case "ttf":
        case "woff":
        case "woff2":
        case "log":
        case "sql":
        case "php":
            return faFileCode;
        case "folder":
            return faFolders
        case "back":
            return faReply
        default:
            return faFileExclamation;
    }
}

class FileBlock extends React.Component {
    render() {
        const { classes } = this.props;

        let ContainerComponent;

        if (this.props.onClick)
            ContainerComponent = ButtonBase;
        else
            ContainerComponent = 'div';

        return (
            <div className={this.props.onDelete ? classes.cardHover : ""} style={{ position: 'relative', ...this.props.mainContainerStyle }}>
                {
                    this.props.onDelete ?
                        <div className={classes.cardHoverUnder} style={{ top: 56, zIndex: 0 }}>
                            <Tooltip
                                title="Remove"
                                placement="bottom"
                                classes={{ tooltip: classes.tooltip }}
                            >
                                <Button
                                    onClick={() => this.props.onDelete()}
                                    color="transparent"
                                    simple
                                    justIcon
                                >
                                    <Delete className={classes.underChartIcons} color="error" />
                                </Button>
                            </Tooltip>
                        </div>
                        : null
                }
                <ContainerComponent
                    onClick={(event) => this.props.onClick && this.props.onClick(event)}
                    onContextMenu={(event) => this.props.onContextMenu && this.props.onContextMenu(event)}
                    className={(this.props.folder ? classes.folderBlockContainer : classes.fileBlockContainer) + " " + decideColor(this.props.fileType) + (this.props.onDelete ? " " + classes.cardHeaderHover : "") + (this.props.onClick ? " " + classes.fileBlockClickable : "")}
                    {...(
                        this.props.folder ?
                        {
                            onDragOver: this.props.onDragOver,
                            onDrop: this.props.onDrop
                        } 
                        :
                        {
                            draggable: true,
                            onDragStart: this.props.onDragStart,
                            onDrag: this.props.onDrag
                        }
                        )
                    }
                >
                    <div className={classes.fileIcon}>
                        <FontAwesomeIcon icon={decideIcon(this.props.fileType)} size="3x" />
                    </div>
                    <span className={classes.fileName}>{this.props.fileName}</span>
                    { this.props.shared ? <div style={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}><Share fontSize="small" /></div> : null }
                    {
                        this.props.image ?
                            <div className={classes.fileBlockImage} style={{ ...(this.props.image ? { backgroundImage: "url(" + this.props.image + ")", backgroundSize: '100%', backgroundRepeat: 'no-repeat', backgroundBlendMode: 'darken' } : {}) }}></div>
                            : null
                    }
                </ContainerComponent>
            </div>
        );
    }
}

export default withStyles({ ...dashboardStyle, ...fileBlockStyle })(FileBlock);